import { range } from 'mathjs';
import {
  MEAN_LABEL,
  MEDIAN_LABEL,
  OTHER_LABEL,
  PERCENTILE_25,
  PERCENTILE_75,
  PUBLIC_TRANSACTIONS,
  SPECIFIED_LABEL,
} from 'pages/Valuations/util/constants';
import {
  get25thPercentileExpression,
  get75thPercentileExpression,
  getCustomPercentileExpression,
  getMeanExpression,
  getMedianExpression,
} from 'pages/Valuations/util/util';
import { getApproachTableName, getCompaniesOrTransactions } from 'pages/ValuationsAllocation/util';
import { getBenchmarkColumnLegend } from './getParser';

const getExpressionByPercentile = (companiesRange, selectedMultiple, specifiedExpression) => {
  switch (selectedMultiple) {
    case MEDIAN_LABEL:
      return getMedianExpression(companiesRange);
    case MEAN_LABEL:
      return getMeanExpression(companiesRange);
    case PERCENTILE_25:
      return get25thPercentileExpression(companiesRange);
    case PERCENTILE_75:
      return get75thPercentileExpression(companiesRange);
    case SPECIFIED_LABEL:
      return specifiedExpression;
    case OTHER_LABEL:
      return '';
    default:
      return getCustomPercentileExpression(companiesRange, selectedMultiple);
  }
};

const getFormulaExpression = params => {
  const { approach, alias, columnLegend, selectedMultipleValue } = params;

  if (!approach) {
    return '';
  }

  const approachData = approach.valuations_approach_gpt ?? approach.valuations_approach_gpc;

  const tableName = getApproachTableName({ approach });
  const approachType = approach.approach_type;

  const approachColumnLegend = getBenchmarkColumnLegend(approachType, alias, columnLegend);

  const companiesRows = getCompaniesOrTransactions(approachData);
  const companiesRange = range(1, companiesRows.length + 1)
    .map(rowNumber => `${tableName}.${approachColumnLegend}${rowNumber + 2}`)
    .toString()
    .replace(/"/g, '');

  const offset = approachType === PUBLIC_TRANSACTIONS ? 11 : 9;
  const specifiedExpression = `=${tableName}.${approachColumnLegend}${companiesRows.length + offset}`;

  return getExpressionByPercentile(companiesRange, selectedMultipleValue, specifiedExpression);
};

export default getFormulaExpression;
